import { css } from '@emotion/css';
import vars from '../../../../../vars';
import { FormCheckbox, FormToggle } from '../../../../components/Form/FormInputs';
import { FormItem } from '../../../../components/Form/FormItem';

const toggleMargin = css({
    marginTop: `-${vars.standardpadding}`,
    marginBottom: `${vars.standardpadding}`,
    label: 'toggle-margin',
});

interface Props {
    name: string;
    caption: string;
    label: string;
    isDisabled?: boolean;
    isToggle?: boolean;
}

export default function ConfigWithCaption({ name, caption, label, isDisabled, isToggle = false }: Props) {
    return (
        <section>
            <div>
                <FormItem
                    name={name}
                    type="checkbox"
                    label={label}
                    inputComponent={isToggle ? FormToggle : FormCheckbox}
                    inputProps={
                        isToggle
                            ? {
                                  disabled: isDisabled,
                                  wrapperClassName: toggleMargin,
                              }
                            : {
                                  disabled: isDisabled,
                              }
                    }
                />
            </div>
            <aside className={isToggle ? toggleMargin : undefined}>{caption}</aside>
        </section>
    );
}
